<template>
  <div class="cart-popup__dialog">
    <TripleEyeHeader />

    <!-- 00_intro -->
    <div class="cart-popup__content height-auto">
      <div class="content_eyecare bgEvent">
        <p class="eyecare_tit txtC">
          몸이 천냥이면 눈은 구백냥!<br>
          트리플 아이케어 프로그램과 함께하는<br>
          <strong class="color_orange" style="font-size:28px">“눈 건강 자가진단 이벤트”</strong><br>
          간편하게 자가진단 하시고 경품에도 응모해보세요.<br>
          <span style="color:#aaa;font-size:12px;text-align:center;line-height:1;display:inline-block">* 이벤트 응모는 1인당 한번씩만 가능합니다.</span>
          <br><br>
        </p>
        <div class="txtC"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/00_intro_vis.png" alt="Eye Care Event" style="width:100%;max-width:280px"></div>
        <p style="color:#aaa;font-size:9px;text-align:right">CN001953</p>
      </div>
    </div>
    <div class="cart-popup__item-link">
      <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="$emit('clickStart')">자가진단 시작!</button>
    </div>
  </div>
  <!-- //00_intro -->
</template>

<script>
import TripleEyeHeader from './header.vue'

export default {
  name: 'TripleIntro',
  components: {
    TripleEyeHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/views/triple-eye-care/component/intro.vue